/* eslint-disable no-unused-vars */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { Button } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import clsx from 'clsx';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import {
  getTBillTableDetails,
  updateTBillRatesTableDetail,
  setUpdateTBillData,
  setTBillEditedData,
  addNewRowData,
  setTBillExtraState,
  tBillTableError,
} from '../store/actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { SAVE_SUCCESS } from '../../../../SharedModules/AppConstants';
import {
  FORMAT_VALIDATION_ERR,
  REQUIRED_ERR,
  UNSAVED_CHANGES_STR,
} from './constantData';
import PDFExportPanel from '../../../../SharedModules/pdfExport/PDFExportPanel';
import Grid from '../../../../SharedModules/Table/tableGrid';

import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import RateTableInput from './gridComponents/rateTableInput';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { tBillTableHead } from './gridComponents/tableHead';
import {
  checkActionAccessByRole,
  isReadOnly as isRead,
  PaperComponent,
} from '../../../../SharedModules/utilities/utilities';
import { closeTab } from '../../../../SharedModules/CommonUtilities/commonUtilities';

// above line imported avoide the colums swipe issues
function TBill(props) {
  const dispatch = useDispatch();
  const gridRef = React.useRef(); // Optional - for accessing Grid's API
  const [gridApi, setGridApi] = React.useState(gridRef);
  const [columnApi, setColumnApi] = React.useState(null);
  const searchTBillTableDetails = (value) =>
    dispatch(getTBillTableDetails(value));
  const updateRatesDetails = (value) =>
    dispatch(updateTBillRatesTableDetail(value));
  const setEditedData = (value) => dispatch(setTBillEditedData(value));
  const [edit1, setEdit] = React.useState(false);
  const [newData, setNewData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [filterRest, setFilterRest] = React.useState(false);
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly = isRead(props.location.pathname, loginState)?.readOnly || false;
  }
  const data = useSelector(
    (state) => state.sharedState.TBillTableReducer.rebateTBillSearchResult.data
  );
  const resultData = useSelector(
    (state) => state.sharedState.TBillTableReducer.allTBillList
  );
  const tBillErrorMsg = useSelector(
    (state) => state.sharedState.TBillTableReducer.errorField
  );
  const editedData = useSelector(
    (state) => state.sharedState.TBillTableReducer.editedData
  );
  const extraState = useSelector(
    (state) => state.sharedState.TBillTableReducer.extraState
  );
  const fullScreenView = useSelector(
    (state) => state.sharedState.TBillTableReducer.extraState.fullScreenView
  );
  const edit = useSelector(
    (state) => state.sharedState.TBillTableReducer.extraState.edit
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const setUpdateTBillDataList = (value) => dispatch(setUpdateTBillData(value));
  const setState = (value) => dispatch(setTBillExtraState(value));
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [total, setTotal] = React.useState();
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [isError, setIsError] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [fieldError, setFieldError] = React.useState([]);
  const childRef = React.useRef(null);
  const [add, setAdd] = React.useState(false);
  const [keyValue, setKeyValue] = React.useState({});
  // const logInUserID = localStorage.getItem('logInUser');
  const [isFilter, setIsFilter] = React.useState(false);
  const rx_live = /^\d\.\d{6}$/;
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  /** Insert row is allowed only with role access and when the screen is not read-only. */
  const addInsertRowDisabled = !isEnablebyRole || isReadOnly;
  const logInUserID = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const handleError = (key, value) => {
    const errorMsg = {
      ...tBillErrorMsg,
      [key]: value,
    };
    dispatch(tBillTableError(errorMsg));
  };

  const setStateChange = (key, val) => {
    setState({
      ...extraState,
      [key]: val,
    });
  };

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  React.useEffect(() => {
    setNewData(resultData);
    if (resultData) {
      setLoading(false);
    }
    setTotal(resultData && resultData.length > 0 ? resultData.length : '0');
  }, [resultData]);

  React.useEffect(() => {
    const values = {};
    if (
      localStore &&
      localStore.length > 0 &&
      localStore.filter((x) => {
        return x.navTo === '/tBill' && x.isRefresh;
      }).length > 0
    ) {
      setLoading(true);
      dispatch(
        tBillTableError({
          errorMessages: [],
          isError: false,
          showRateErr: false,
        })
      );
      setState({
        fullScreenView: false,
        edit: false,
      });
      setEditedData([]);
      const newObj = localStore.map((item) => {
        if (item.navTo === '/tBill') {
          item.isRefresh = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      searchTBillTableDetails(values);
      if (data && data.length > 0) {
        setUpdateTBillDataList(data);
      }
    }
  }, [data]);

  // Tab highlighter POC
  React.useEffect(() => {
    const errMsg = tBillErrorMsg.errorMessages;
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/tBill' && edit) {
          item.isFormDirty = true;
        } else {
          item.isFormDirty = false;
        }
        if (item.navTo === '/tBill') {
          if (edit && !_.isEmpty(errMsg)) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [edit, tBillErrorMsg]);

  // Remove duplicate data and change the allowEntryInd value
  const removeDuplicateData = (dupData) => {
    const filteredArr = dupData.reduce((acc, current) => {
      const x = acc.find(
        (item) =>
          item.effectiveDateWithoutTime === current.effectiveDateWithoutTime
      );
      if (!x) {
        return acc.concat([current]);
      }
      return acc;
    }, []);
    const Data = filteredArr.map((x) => {
      x.lastUpdateUserid = logInUserID;
      if (x.allowEntryInd) x.allowEntryInd = '1';
      else x.allowEntryInd = '0';
      return x;
    });
    return Data;
  };

  const isFormValid = () => {
    let showRateErr = false;
    const errorMessagesArray = [];
    editedData.forEach((item) => {
      if (item.tbillRate == '') {
        showRateErr = true;
        errorMessagesArray.push(REQUIRED_ERR);
      } else if (!rx_live.test(item.tbillRate)) {
        showRateErr = true;
        errorMessagesArray.push(FORMAT_VALIDATION_ERR);
      }
    });
    handleError('showRateErr', showRateErr);
    if (errorMessagesArray.length > 0) {
      handleError('errorMessages', [...new Set(errorMessagesArray)]);
      return false;
    }
    handleError('errorMessages', []);

    return true;
  };

  const masterDataSave = (e) => {
    handleError('errorMessages', []);
    setSuccessMessages([]);
    if (editedData.length > 0) {
      const dataToUpdate = removeDuplicateData(editedData);
      setEditedData(dataToUpdate);
      if (isFormValid('save')) {
        setLoading(true);
        updateRatesDetails(dataToUpdate);
        setEditedData([]);
        setSuccessMessages([SAVE_SUCCESS]);
        const updateTabs = localStore;
        if (
          updateTabs &&
          updateTabs.length > 0 &&
          updateTabs.filter((x) => {
            return x.navTo === '/tBill' && x.isFormSave;
          }).length > 0
        ) {
          closeTab('/tBill', props.history, dispatch);
        }
      }
      setOpen(false);
    }
    setStateChange('edit', false);
  };
  // Close Popup POC---
  React.useEffect(() => {
    const updateTabs = localStore;
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/tBill' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/tBill' && item.isFormSave) {
          if (edit && _.isEmpty(tBillErrorMsg.errorMessages)) {
            masterDataSave();
          }
        }
        return item;
      });
    }
  }, [localStore]);

  // get edited data
  const onEditingStopped = React.useCallback(
    (e) => {
      setSuccessMessages([]);
      setStateChange('edit', true);
      if (e && e.value !== e.oldValue) {
        const obj = e.data;
        obj.index = e.rowIndex;
        obj.isEdit = true;
        obj.isError = false;
        const tempObj = !_.isEmpty(editedData)
          ? _.filter(editedData, (l) => l.id !== e.data?.id)
          : [];
        tempObj.push(obj);
        setEditedData(tempObj);
      }
    },
    [editedData]
  );

  // set save alert open
  const openSave = () => {
    setSuccessMessages([]);

    setOpen((edit && _.isEmpty(tBillErrorMsg.errorMessages)) || false);
  };

  // set save alert close
  const handleSaveClose = () => {
    setOpen(false);
  };

  // set Cancel alert open
  const open_Cancel = () => {
    setSuccessMessages([]);
    setOpenCancel(true);
  };

  // set Cancel Alert close and reset all data
  const handelCancel = () => {
    setEditedData([]);
    handleError('errorMessages', []);
    setSuccessMessages([]);
    setFilterRest(true);
    setLoading(true);
    setStateChange('edit', false);
    dispatch(addNewRowData(data));
    // if(add){dispatch(addNewRowData(data));}
    setOpenCancel(false);
  };

  // set Cancel Alert close
  const handelCancelClose = () => {
    setOpenCancel(false);
  };

  const updateErrorField = (v) => {
    if (v.length > 0) {
      handleError('errorMessages', [...new Set(v)]);
    } else {
      handleError('errorMessages', []);
    }
  };

  const updateDataAction = React.useCallback(
    (action, cellInfo) => {
      const fieldErrorNew = [];
      let allList = cellInfo.node.parent.allLeafChildren;
      if (allList && !_.isEmpty(allList)) {
        allList = _.map(allList, (l) => l.data);
        allList.forEach((item) => {
          if (item.tbillRate == '') {
            fieldErrorNew.push(REQUIRED_ERR);
          } else if (!rx_live.test(item.tbillRate)) {
            fieldErrorNew.push(FORMAT_VALIDATION_ERR);
          }
        });
      }
      updateErrorField(fieldErrorNew);
    },
    [editedData]
  );

  const frameworkComponents = {
    TextBoxRender: (cellInfo) => (
      <RateTableInput
        cellInfo={cellInfo}
        updateDataAction={updateDataAction}
        addAction={addTBillRate}
        isEnablebyRole={isEnablebyRole}
      />
    ),
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  }, []);

  const onFilterChangedGrid = useCallback((e) => {
    setTotal(e.api.getDisplayedRowCount());
    const filterLength = Object.keys(e.api.getFilterModel()).length;
    if (filterLength > 0) setIsFilter(true);
    else setIsFilter(false);
  }, []);

  const handleClearFilter = () => {
    childRef.current.clearFilters();
    setFilterRest(false);
  };

  React.useEffect(() => {
    if (filterRest) {
      searchTBillTableDetails({});
      handleClearFilter();
      if (add) {
        dispatch(addNewRowData(newData));
      }
      setFilterRest(false);
    }
  }, [filterRest]);

  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  function formatDate(date) {
    return [
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
      date.getFullYear(),
    ].join('/');
  }

  const addTBillRate = (e, cellInfo, data, rdata) => {
    if (addInsertRowDisabled) {
      if (e?.preventDefault) e.preventDefault();
      return;
    }
    childRef && childRef.current.clearFilters();
    if (cellInfo)
      cellInfo.columnApi.applyColumnState({
        state: [{ colId: 'effectiveDateWithoutTime', sort: 'desc' }],
        defaultState: { sort: null },
      });
    else
      columnApi.applyColumnState({
        state: [{ colId: 'effectiveDateWithoutTime', sort: 'desc' }],
        defaultState: { sort: null },
      });
    setAdd(true);
    setSuccessMessages([]);
    let newDate;
    if (rdata) newDate = new Date(rdata[0].effectiveDateWithoutTime);
    else newDate = new Date(resultData[0].effectiveDateWithoutTime);
    newDate.setDate(newDate.getDate() + 7);
    const blankObj = {
      tbillEffectiveDt: `${formatDate(newDate)} 00:00`,
      tbillRate: '0.000000',
      lastUpdateDt: '',
      lastUpdateUserid: logInUserID,
      isEdit: true,
      effectiveDateWithoutTime: formatDate(newDate),
      index: 0,
      id: uuidv4(),
    };
    dispatch(addNewRowData(blankObj));
    if (data) {
      const newData = [...data];
      newData.push(blankObj);
      setEditedData(newData);
    } else {
      editedData.push(blankObj);
      setEditedData(editedData);
    }
    requestAnimationFrame(() => {
      if (gridApi !== null) {
        gridApi.forEachNode((node) =>
          node.rowIndex ? 0 : node.setSelected(true)
        );
        gridApi.ensureColumnVisible('tbillRate');
        gridApi.setFocusedCell(0, 'tbillRate');
      }
    },);
    setStateChange('edit', true);
  };

  const getShowViewHistoryPlan = () => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.tbillEffectiveDt;
    const effectiveDate = selectedRow ? `${selectedRow} 00:00` : `${resultData[0].effectiveDateWithoutTime} 00:00`;
    setKeyValue({ T_BILL_EFFECTIVE_DT: effectiveDate });
    setShowViewHistory(true);
  };

  const gridHeight = fullScreenView ? '70vh' : 400;
  // Ag-grid
  return (
    <div className="tBillPanel" data-testid="TBillPanel">
      <Spinner load={loading} />
      <div className="panel tBillPanel-space devider-line pb-0">
        <div>
          <Dialog
            open={open}
            onClose={handleSaveClose}
            data-testid="handleSaveClose"
            className="multiGroupDialog custom-dialog-box dialog-420"
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogContent>
              <div className="custom-panel">
                <div
                  className="panel-header"
                  style={{ cursor: 'move' }}
                  id="draggable-dialog-title"
                >
                  <span className="float-left"> Save </span>
                  <span className="float-right" onClick={handleSaveClose}>
                    <i className="fa fa-times-circle" aria-hidden="true" />
                  </span>

                  <div className="clearfix" />
                </div>
                <div className="text-center modal-alignment">
                  <DialogContentText style={{ color: 'black' }}>
                    Are you sure you want to Save your changes? To revert changes, click on Cancel
                  </DialogContentText>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <div className="btn-wrapper my-2">
                <Button
                  onClick={masterDataSave}
                  data-testid="masterDataSave"
                  className="btn btn-success btn-search mr-2"
                >
                  <SVGComponent iconName="Icon_awesome-check-circle" />
                  Yes
                </Button>

                <Button
                  onClick={handleSaveClose}
                  className="btn btn-cancel btn-primary mr-2"
                  color="primary"
                  autoFocus
                >
                  <SVGComponent iconName="Icon-cancel" />
                  No
                </Button>
              </div>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openCancel}
            onClose={handelCancelClose}
            data-testid="handelCancelClose"
            className="multiGroupDialog custom-dialog-box dialog-420"
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogContent>
              <div className="custom-panel">
                <div
                  className="panel-header"
                  style={{ cursor: 'move' }}
                  id="draggable-dialog-title"
                >
                  <span className="float-left"> Cancel </span>
                  <span className="float-right" onClick={handelCancelClose}>
                    <i className="fa fa-times-circle" aria-hidden="true" />
                  </span>
                  <div className="clearfix" />
                </div>
                <div className="text-center  modal-align-cancel ">
                  <DialogContentText style={{ color: 'black' }}>
                    {UNSAVED_CHANGES_STR}
                  </DialogContentText>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <div className="btn-wrapper my-2">
                <Button
                  onClick={handelCancel}
                  data-testid="handelCancel"
                  className="btn btn-success btn-search mr-2"
                >
                  <SVGComponent iconName="Icon_awesome-check-circle" />
                  Yes
                </Button>

                <Button
                  onClick={handelCancelClose}
                  className="btn btn-cancel btn-primary"
                  color="primary"
                  autoFocus
                >
                  <SVGComponent iconName="Icon-cancel" />
                  No
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        </div>
        {!fullScreenView && (
          <div>
            <CustomSeparator parent1="Maintain" parent2="T-Bill Rates" />
          </div>
        )}
        <div>
          <DisplayErrorMessages
            errorMessages={tBillErrorMsg.errorMessages || []}
          />
          {/* <DisplayErrorMessages errorMessages={errorMessages} /> */}
          <DisplaySuccessMessages successMessages={successMessages} />
          {!fullScreenView && (
            <div className="flex-block justify-end pb-1">
              <div className="btn-wrapper float-right">
                <Button
                  className="btn btn-success btn-save"
                  onClick={openSave}
                  // onMouseDown={openSave}
                  data-testid="openSave"
                  disabled={!edit || isReadOnly}
                >
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  data-testid="open_Cancel"
                  onClick={() => open_Cancel()}
                  disabled={!edit || isReadOnly}
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </div>
        <div className="panel-header top-header">
          {!fullScreenView ? (
            <a
              href="#"
              data-testid="addTBillRate"
              className={clsx(
                'icon-plus float-left',
                addInsertRowDisabled && 'frr-disable-anchor'
              )}
              aria-disabled={addInsertRowDisabled}
              tabIndex={addInsertRowDisabled ? -1 : 0}
              onClick={(ev) => {
                ev.preventDefault();
                if (addInsertRowDisabled) return;
                addTBillRate(ev);
              }}
            >
              <h2 className="my-2">Insert T-Bill Rates</h2>
            </a>
          ) : (
            ''
          )}
          <div className="float-right th-icon-group mt-2">
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="filter-tooltip">Reset All Filters</Tooltip>}
            >
              {isFilter ? (
                <div
                  className="th-icon ic-filter-activate"
                  data-testid="handleClearFilter"
                  onClick={handleClearFilter}
                >
                  <span className="ic-title"> Filter </span>{' '}
                </div>
              ) : (
                <div className="th-icon ic-filter">
                  <span className="ic-title"> Filter </span>{' '}
                </div>
              )}
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="history-tooltip">View History</Tooltip>}
            >
              <div
                className="th-icon ic-history"
                onClick={getShowViewHistoryPlan}
                data-testid="getShowViewHistoryPlan"
                tabIndex="0"
              >
                <span className="ic-title"> History </span>
              </div>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="history-tooltip"> Actions </Tooltip>}
            >
              <div className="th-icon ic-actions">
                <PDFExportPanel
                  gridApi={gridApi}
                  columnApi={columnApi}
                  fileName="T-Bill Rates"
                  childRef={childRef}
                />
              </div>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="fullScreen-tooltip">Fullscreen</Tooltip>}
            >
              <div
                className={clsx(
                  'th-icon',
                  fullScreenView ? 'ic-fulScreen-exit' : 'ic-fulScreen'
                )}
                data-testid="setFullScreenView"
                onClick={() =>
                  setStateChange('fullScreenView', !fullScreenView)
                }
                tabIndex="0"
              >
                <span className="ic-title"> Full Screen </span>
              </div>
            </OverlayTrigger>
          </div>
        </div>
      </div>
      <div className="panel tBillPanel-space pb-0">
        <div className="clearfix" />
        <Grid
          onGridReady={onGridReady}
          ref={childRef}
          rowData={resultData}
          fileName="T-Bill Rates"
          columnDefs={tBillTableHead}
          setGridApi={setGridApi}
          setColumnApi={setColumnApi}
          gridHeight={gridHeight}
          noGlobalSort
          onFilterChanged={onFilterChangedGrid}
          onCellValueChanged={onEditingStopped}
          data-testid="onEditingStopped"
          setTotal={setTotal}
          frameworkComponents={frameworkComponents}
          singleClickEdit
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          // suppressRowClickSelection={true}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          disableAddAction={addInsertRowDisabled}
        />

        <p className="total-results" tabIndex="0">
          Total Results: <b>{total?.toLocaleString('en-US')}</b>
        </p>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="T_BILL_RATE"
          keyValue={keyValue}
          isSpinner
        />
      )}
    </div>
  );
}
export default withRouter(TBill);
